// Nouvelle overview (bêta) et tableaux de bord personnalisés :
// - hors prod : VUE_APP_OVERVIEW_V2 (true en sandbox / local) ;
// - en prod (VUE_APP_OVERVIEW_V2=false) : équipe Mashup Web Social (domaine e-mail) et comptes clients de la bêta (id de compte).
import { betaProgramHas } from '@/utils/betaFeatures'

const BETA_EMAIL_DOMAINS = ['@mashup-web.com']
// Comptes clients ouverts à la bêta (users.account / accounts.id)
const BETA_ACCOUNT_IDS = []

function currentUser(user) {
  if (user && (user.email || user.account)) return user
  try {
    return localStorage.user && localStorage.user !== 'undefined' ? JSON.parse(localStorage.user) : null
  } catch (e) {
    return null
  }
}

/**
 * @param {Object} [user] - utilisateur courant (store) ; à défaut celui du localStorage
 */
export function overviewV2Enabled(user) {
  if (process.env.VUE_APP_OVERVIEW_V2 === 'true') return true
  const u = currentUser(user)
  if (!u) return false
  if (u.account && BETA_ACCOUNT_IDS.includes(String(u.account))) return true
  if (betaProgramHas('overview_v2', u)) return true
  const email = String(u.email || '').trim().toLowerCase()
  return !!email && BETA_EMAIL_DOMAINS.some(domain => email.endsWith(domain))
}
